module.exports = __webpack_public_path__ + "img/Bg@3x.09ee5117.png";